import { Layout } from 'components/layout';
import { ApartsmentLayoutsItem } from '../apartsment-layouts-item/apartsment-layouts-item';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';

export const ApartmentLayouts = () => {
  const apartmentsList = [
    {
      image: '/assets/images/apartments/23,85.png',
      title: 'Студия, 23,85 м²',
      price: 'От 5,5 млн руб',
      oldPrice: 'от 7,4 млн руб',
      commonSpace: '23,85 м²',
      livingSpace: '12,3 м²',
      dialogTitle: 'Студия',
    },
    // {
    //   image: '/assets/images/apartments/3с_31,53.png',
    //   title: '1-комнатная, 31,53 м²',
    //   price: 'От 6,6 млн руб. ',
    //   oldPrice: 'от 8,8 млн руб',
    //   commonSpace: '31,53 м²',
    //   livingSpace: '12,20 м²',
    //   dialogTitle: 'Однокомнатная квартира',
    // },
    {
      image: '/assets/images/apartments/40_57.png',
      title: '2-комнатная (евро) , 40,57 м²',
      price: 'От 7,6 млн руб.',
      oldPrice: 'от 10,1 млн руб',
      commonSpace: '40,57 м²',
      livingSpace: '24,98 м²',
      dialogTitle: 'Двухкомнатная квартира (евро)',
    },
    {
      image: '/assets/images/apartments/56,94.png',
      title: '2-комнатная, 56,94 м²',
      price: 'От 10,5 млн руб.',
      oldPrice: 'от 14 млн руб',
      commonSpace: '56,94 м²',
      livingSpace: '35,39 м²',
      dialogTitle: 'Двухкомнатная квартира',
    },
    {
      image: '/assets/images/apartments/60_76.png',
      title: '3-комнатная (евро), 60,76 м²',
      price: 'От 11,2 млн руб.',
      oldPrice: 'от 15 млн руб',
      commonSpace: '60,76 м²',
      livingSpace: '39,69 м²',
      dialogTitle: 'Трехкомнатная квартира',
    },
    {
      image: '/assets/images/apartments/4с_60,76.png',
      title: '3-комнатная, 64,12 м²',
      price: 'От 11,8 млн руб.',
      oldPrice: 'от 15,8 млн руб',
      commonSpace: '64,12 м²',
      livingSpace: '41,76 м²',
      dialogTitle: 'Трехкомнатная квартира',
    },
  ];

  return (
    <section
      className="bg-plt-secondary/50 pt-[72px] pb-[48px] font-open-sans screen-900:pt-6 screen-900:bg-plt-white screen-900:pb-0">
      <Layout.Container>
        <div className="bg-plt-white rounded-[40px] pt-10 pb-[52px] screen-900:rounded-none">
          <h3 className="uppercase font-bold text-center text-[32px] text-plt-black screen-700:text-lg">
            БОЛЬШОЙ ВЫБОР ПЛАНИРОВОЧНЫХ РЕШЕНИЙ
          </h3>
          {/*<div className="mt-16 grid grid-cols-5 gap-4 px-[33px] screen-1150:hidden">*/}
          {/*  {apartmentsList.map((apartment) => (*/}
          {/*    <ApartsmentLayoutsItem*/}
          {/*      key={apartment.title}*/}
          {/*      apartment={apartment}*/}
          {/*    />*/}
          {/*  ))}*/}
          {/*</div>*/}
          <div className="px-[66px] mt-4">
            <Carousel opts={{ align: 'start', loop: true }}>
              <CarouselContent>
                {apartmentsList.map((apartment) => (
                  <CarouselItem
                    key={apartment.title}
                    className="basis-1/5 screen-1300:basis-1/4 screen-1100:basis-1/3 screen-850:basis-1/2 screen-700:basis-full"
                  >
                    <ApartsmentLayoutsItem
                      key={apartment.title}
                      apartment={apartment}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="border-plt-secondary " />
              <CarouselNext className="border-plt-secondary" />
            </Carousel>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
